import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTemplate from '../../../components/template/PageTemplate';
import NoticeStoreSaveContainer from '../../../containers/notice/NoticeStoreSaveContainer';
import { noticeStoreActions } from '../../../store/modules/notice/store';
import { NOTICE_STORE_PAGE_NAME } from '../../../constants/service/app/noticeStoreConstants';

class NoticeStoreCreate extends Component {
  componentDidMount() {
    this.props.prepareAddNoticeStore();
  }

  render() {
    const { addNoticeStore } = this.props;

    return (
      <PageTemplate pageName={NOTICE_STORE_PAGE_NAME.NOTICE_STORE_CREATE}>
        <NoticeStoreSaveContainer pageName={NOTICE_STORE_PAGE_NAME.NOTICE_STORE_CREATE} onSubmit={addNoticeStore} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  prepareAddNoticeStore: noticeStoreActions.prepareAddNoticeStore,
  addNoticeStore: noticeStoreActions.addNoticeStore,
};

export default connect(null, mapDispatchToProps)(NoticeStoreCreate);
